import React from 'react'
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard";

type Props = {
    className?  :string
    height?     : number
    title       : any

    line2?      : any

    onClose?    : {():void}
    onGoBack?   : {():void}
}

export default function ModalV4Header(props:Props) {

    const classes = Classes('header', props.className, {
        'with-go-back'  : !!props.onGoBack,
        // 'h60'           : props.height === 60,
        // 'h90'           : props.height === 90,
        // 'h100'          : props.height === 100,
    })

    const style: any = {}

    if (props.height) {
        style.height = props.height
    }

    const onClose = props.onClose ?
        props.onClose
        :
        (e:any) => {
            e.stopPropagation()
            gd.modal.hide()
        }

    return (
        <div className={classes} style={style}>
            <div className="title">{props.title}</div>
            <ControlButtonStandard className    = "btn-close"
                                   type         = {ControlButtonType.CLOSE}
                                   onClick      = {onClose}/>
            {props.onGoBack && <div className="btn-go-back gd-btn-arrow-left-gray-22" onClick={props.onGoBack}/>}
            {props.line2}
        </div>
    )
}